module.exports = __webpack_public_path__ + "static/media/multichoice.00c8d364.svg";